import DOMPurify from "dompurify"

export function sanitizeHtml(dirty) {
  if (dirty === null || dirty === undefined) {
    return ""
  }
  return DOMPurify.sanitize(String(dirty))
}

export default sanitizeHtml
